// Vendor Libs
import React from 'react';

// Components
import RoleForm from './role-form';

// Containers
import FormData from '../../containers/form-data';

const formName = 'createRole';

const CreateRole = () => (
    <FormData formName={formName}>
        {({resetForm}) => <RoleForm className="create-role" formName={formName} onReset={resetForm} />}
    </FormData>
);

export default CreateRole;
